import React from "react";
import Card from "./card";
import Loading from "./loading";

const CardSkeleton = (props) => <Card {...props}><Loading /></Card>;

export default CardSkeleton;
